import { find, register, findAll } from '../../../../Javascript/Sysmex/Utils'
import '../../../../Javascript/Sysmex/polyfills'

const CookieOptin = el => {
  const componentPrefix = el.dataset.componentprefix
  const forceDisabled = el.dataset.forcedisabled
  const openOnClickSelectorId = el.dataset.openonclickselectorid
  const openOnClickEl = document.getElementById(openOnClickSelectorId)
  const allOptInBtn = find(`.${componentPrefix}customizeAcceptAllBtn`, el)
  const statisticOptInBtn = find(`.${componentPrefix}customizeStatisticBtn`, el)
  const essentialOptInBtn = find(`.${componentPrefix}customizeEssentialBtn`, el)
  const statisticOptIn = getCookie('statistic_opt_in')
  const marketingOptIn = getCookie('marketing_opt_in')
  const essentialOptIn = getCookie('necessary_opt_in')
  const detailsBtn = find(`.${componentPrefix}detailsOpener`, el)
  const detailsCloseBtnMobile = findAll(`.${componentPrefix}closeDetails`, el)
  const vh = window.innerHeight * 0.01

  if ((!statisticOptIn &&
    !marketingOptIn &&
    !essentialOptIn) && !forceDisabled) {
    el.classList.add(`${componentPrefix}active`)
  }

  // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  // set the value in the --vh custom property to the root of the document
  el.style.setProperty(`--${componentPrefix}Vh`, `${vh}px`)

  detailsBtn.addEventListener('click', (e) => {
    e.preventDefault()
    el.classList.toggle(`${componentPrefix}details--open`)
  })

  detailsCloseBtnMobile.forEach(function (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      el.classList.remove(`${componentPrefix}details--open`)
    })
  })

  allOptInBtn.addEventListener('click', () => {
    setCookie('marketing_opt_in')
    setCookie('necessary_opt_in')
    setCookie('statistic_opt_in')
    window.location.reload()
  })

  statisticOptInBtn.addEventListener('click', () => {
    setCookie('necessary_opt_in')
    setCookie('statistic_opt_in')
    unsetCookie('marketing_opt_in')
    window.location.reload()
  })

  essentialOptInBtn.addEventListener('click', () => {
    setCookie('necessary_opt_in')

    const statisticOptIn = getCookie('statistic_opt_in')
    const marketingOptIn = getCookie('marketing_opt_in')
    if (statisticOptIn) {
      setCookie('statistic_opt_in')
    }
    if (marketingOptIn) {
      setCookie('marketing_opt_in')
    }

    window.location.reload()
  })

  if (openOnClickEl) {
    openOnClickEl.addEventListener('click', (e) => {
      e.preventDefault()
      el.classList.add(`${componentPrefix}active`)
    })
  }
}

const getCookie = function (cookieName) {
  const value = '; ' + document.cookie
  const parts = value.split('; ' + cookieName + '=')
  return parts.length === 2 ? parts.pop().split(';').shift() : false
}

const setCookie = function (cookieName) {
  if (cookieName === 'necessary_opt_in') {
    document.cookie = cookieName + '=true; path=/; SameSite=lax; Secure'
  } else {
    const expireDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    document.cookie = cookieName + '=true; expires=' + expireDate.toString() + '; path=/; SameSite=lax; Secure'
  }
}

const unsetCookie = function (cookieName) {
  document.cookie = cookieName + '=false; expires=Thu, 01 Jan 1970 00:00:01 GMT; Max-Age=0; path=/; SameSite=lax; Secure'
}

register('CookieOptin', CookieOptin)
